import { TransformFormatType } from '../../../../models/ITransform';

export function isSpellCheckAvailable(format: TransformFormatType): boolean {
    return ['javascript', 'json'].indexOf(format) === -1 ? true : false;
}